<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-8"></a>
<h2 class="fm-head1">Picture Acknowledgements</h2>
<p class="center"><strong class="b">In the book</strong></p>
<p class="num"><span class="hang">1.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">2.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">3.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">4.</span> John Barker [Public domain]</p>
<p class="num"><span class="hang">5.</span> Public Domain, from the British Library’s collections, 2013</p>
<p class="num"><span class="hang">6.</span> Abraham Storck [Public domain]</p>
<p class="num"><span class="hang">7.</span> Sylvanus Urban [Public domain]</p>
<p class="num"><span class="hang">8.</span> Public Domain, from the British Library’s collections, 2013</p>
<p class="num"><span class="hang">9.</span> tyburntree.wordpress.com [Public domain]</p>
<p class="num"><span class="hang">10.</span> Ralph Gardiner [Public domain]</p>
<p class="num"><span class="hang">11.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">12.</span> en:User:Raymond Palmer [Public domain]</p>
<p class="num"><span class="hang">13.</span> Jan Luyken [Public domain]</p>
<p class="num"><span class="hang">14.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">15.</span> Manchester Art Gallery [Public domain]</p>
<p class="num"><span class="hang">16.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">17.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">18.</span> Attributed to Henri Beaubrun (1603-1677) [Public domain]</p>
<p class="num"><span class="hang">19.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">20.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">21.</span> Susan Doran [Public domain]</p>
<p class="num"><span class="hang">22.</span> Public Domain, from the British Library’s collections, 2013</p>
<a id="VPS-9"></a>
<p class="center"><em class="i">Picture Acknowledgements</em></p>
<p class="num"><span class="hang">23.</span> Public Domain, from the British Library’s collections, 2013</p>
<p class="num"><span class="hang">24.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">25.</span> Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">26.</span> Author’s private collection</p>
<p class="num"><span class="hang">27.</span> Author’s private collection</p>
<p class="num"><span class="hang">28.</span> Author’s private collection</p>
<p class="num"><span class="hang">29.</span> Author’s private collection</p>
<p class="num"><span class="hang">30.</span> Author’s private collection</p>
<p class="num"><span class="hang">31.</span> Author’s private collection</p>
<p class="num"><span class="hang">32.</span> Author’s private collection</p>
<p class="num"><span class="hang">33.</span> Author’s private collection</p>
<p class="num"><span class="hang">34.</span> Jacob Truedson Demitz for Ristesson History [Public domain]</p>
<p class="num"><span class="hang">35.</span> The Portable Antiquities Scheme/The Trustees of the British Museum [CC BY-SA 2.0 (https://creativecommons.org/licenses/ by-sa/2.0)]</p>
<p class="center"><strong class="b">On the cover</strong></p>
<p class="num"><span class="hang">1.</span> (Townspeople fleeing to the countryside to escape the plague in England, 1630. Hand-coloured woodcut.) North Wind Picture Archives / Alamy Stock Photo</p>
<p class="num"><span class="hang">2.</span> (The beheading of Charles I outside the Banqueting Hall of Whitehall in 1649. Engraving with etching.) Wellcome Collection. CC BY</p>
<p class="num"><span class="hang">3.</span> (Surgeons performing an operation on a woman’s breast in the seventeenth century.) Wellcome Collection. CC BY</p>
<p class="center"><strong class="b">Chapter headers</strong></p>
<p class="num"><span class="hang">1.</span> (Skull on a book) Public Domain, from the British Library’s collections, 2013</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Acknowledgements.vue?2acd3b77